var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 65",
    style: {
      enableBackground: "new 0 0 66 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6F7;}\n\t.st1{fill:#4343B5;}\n\t.st2{fill:none;}\n\t.st3{fill:#E3F2FF;}\n\t.st4{fill:#7ADDB6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028_1_",
    transform: "translate(-541 -946.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_489_1_",
    transform: "translate(541 946.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,65C14.6,65,0,50.4,0,32.5S14.6,0,32.5,0S65,14.6,65,32.5S50.4,65,32.5,65z M32.5,2 C15.7,2,2,15.7,2,32.5S15.7,63,32.5,63S63,49.3,63,32.5S49.3,2,32.5,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_490_1_",
    transform: "translate(563 946.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 10,
    cy: 32.5,
    rx: 10,
    ry: 32.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,65C3.5,65,0,48.3,0,32.5C0,16.8,3.5,0,10,0s10,16.7,10,32.5S16.5,65,10,65z M10,2C6.2,2,2,14.5,2,32.5 S6.2,63,10,63s8-12.5,8-30.5C18,14.6,13.8,2,10,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_77_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.9,
    y: 961.2,
    className: "st1",
    width: 52.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_78_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.4,
    y: 977.7,
    className: "st1",
    width: 64.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_79_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.9,
    y: 994.3,
    className: "st1",
    width: 53.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_491_1_",
    transform: "translate(573 949.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 17,
    cy: 16.5,
    rx: 17,
    ry: 16.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,33C7.6,33,0,25.6,0,16.5S7.7,0,17,0s17,7.4,17,16.5S26.4,33,17,33z M17,2C8.7,2,2,8.5,2,16.5 S8.8,31,17,31s15-6.5,15-14.5S25.3,2,17,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_393_1_",
    transform: "translate(587 954.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.5,0L3.5,0C5.5,0,7,1.6,7,3.5v15c0,2-1.5,3.5-3.5,3.5l0,0C1.6,22,0,20.4,0,18.5v-15C0,1.6,1.6,0,3.5,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,22C1.6,22,0,20.4,0,18.5v-15C0,1.6,1.6,0,3.5,0S7,1.6,7,3.5v15C7,20.5,5.5,22,3.5,22z M3.5,2 C2.7,2,2,2.7,2,3.5v15C2,19.4,2.7,20,3.5,20S5,19.3,5,18.5v-15C5,2.7,4.4,2,3.5,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_394_1_",
    transform: "translate(601.5 961.555) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.5,0L3.5,0C5.5,0,7,1.5,7,3.5v15C7,20.4,5.4,22,3.5,22l0,0C1.6,22,0,20.4,0,18.5v-15C0,1.5,1.6,0,3.5,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,3.5v15C7,20.4,5.4,22,3.5,22S0,20.4,0,18.5v-15C0,1.5,1.6,0,3.5,0S7,1.5,7,3.5z M2,18.5 C2,19.3,2.7,20,3.5,20S5,19.3,5,18.5v-15C5,2.7,4.3,2,3.5,2S2,2.6,2,3.5V18.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_395_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M590.5,974.1L590.5,974.1c-0.8,0-1.5-0.7-1.5-1.5v-15c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5v15 C592,973.4,591.4,974.1,590.5,974.1z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 14.4,
    className: "st1",
    width: 1.9,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 21.5,
    className: "st1",
    width: 1.9,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.1,
    y: 14.4,
    className: "st1",
    width: 1.9,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.1,
    y: 21.4,
    className: "st1",
    width: 1.9,
    height: 2.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverage);
export default __webpack_public_path__ + "static/media/coverage.e68dfcfe379d1a01725125e746a84cef.svg";
export { ForwardRef as ReactComponent };